import type { FunnelTemplate } from "schemas/generated/funnelTemplate";

import React from "react";

import { useNavigate } from "react-router-dom";

import FunnelTemplateCard from "./FunnelTemplateCard";

function RecommendedFunnelTemplateGrid({
  templates,
}: {
  templates: FunnelTemplate[];
}) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-4">
      <h2 className="header-h4 text-default">Recommended funnels</h2>

      <div className="flex gap-3">
        {templates.map((template) => (
          <FunnelTemplateCard
            key={template.id}
            template={template}
            onClick={() =>
              navigate(
                `${window.location.pathname}/new?initialSelectedTemplateId=${template.id}`,
              )
            }
          />
        ))}
      </div>
    </div>
  );
}

export default RecommendedFunnelTemplateGrid;
